<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card :title="$t('AutomaticCashRegisterReportList') | ToUppercase">
                <vs-button class="float-left" color="success" type="filled" to="/report/automaticCashRegister/add">{{$t('AddAutomaticCashRegisterReport')}}</vs-button>

                <vs-table :noDataText="$t('NoReportsFound')" max-items="14" pagination search :data="cashRegisterReports">
                    <template slot="thead">
                        <vs-th sort-key="id">#</vs-th>
                        <vs-th>{{ $t("Date") }}</vs-th>
                        <vs-th>{{ $t("Actions") }}</vs-th>
                        <vs-th>{{ $t("Download") }}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <tbody>
                            <vs-tr :data="tr" :key="data[index].id" v-for="(tr, index) in data">
                                <vs-td>{{ data[index].id}}</vs-td>
                                <vs-td>{{ data[index].date_formated}}</vs-td>
                                <vs-td>
                                    <vs-button v-if="data[index].pdf_name === ''" color="primary" class="" @click="$router.push('/report/automaticCashRegister/edit/' + data[index].id)" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
                                    <vs-button v-else disabled color="primary" class="" @click="$router.push('/report/automaticCashRegister/edit/' + data[index].id)" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
                                </vs-td>
                                <vs-td v-if="data[index].pdf_name === ''" class="grid justify-items-start">
                                    <vs-button class="float-left" color="primary" @click="exportPDF(data[index].id)" type="border" icon="picture_as_pdf">{{ $t("GeneratePdf") }}</vs-button>
                                </vs-td>
                                <vs-td v-else class="grid justify-items-start">
                                    <vs-button class="float-left" color="primary" @click="exportPDF(data[index].id)" type="border" icon="picture_as_pdf">PDF</vs-button>
                                </vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                </vs-table>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                cashRegisterReports: [],
            };
        },
        methods: {
            updateAutomaticCashRegisterReports() {
                this.$vs.loading();
                const thisIns = this;
                this.$http.get('/report?type=automaticCashRegisterReport')
                .then(function (response) {
                    thisIns.cashRegisterReports = response.data.reverse();
                    console.log(thisIns.cashRegisterReports);
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju dnevnih poročil.",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            exportPDF(reportId){
                this.$vs.loading();

                const thisIns = this;
                this.$http.post("/report/generateAutomaticCashRegisterReportPdf", {
                    id: reportId,
                }).then(function (response) {
                    window.open('/api/pdf/report/' + response.data + '?type=automaticCashRegisterReport');
                    thisIns.updateAutomaticCashRegisterReports();
                    thisIns.$vs.notify({
                        text: "PDF uspečno generiran",
                        color: "success",
                    });
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri generiranju.",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
        },
        created() {
            this.updateAutomaticCashRegisterReports();
        },
    };
</script>
